import React from 'react';

/** Purple 270° arc gauge (Figma 1741:55510): light #B98AF9 track + #6C09F7
 *  progress, 90° gap at the bottom. Centre "{pct}%" 22.5/500 + "Good fit for
 *  brand" 13.5/400. */
export function SafetyGauge({ score }: { score: number }) {
  const size = 180;
  const stroke = 18;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score));

  // 270° gauge: visible arc = ¾ of the circle, 90° gap centred at the bottom.
  // rotate(135deg) moves the dash start from 3 o'clock to the 7:30 position so
  // the arc sweeps clockwise over the top and the gap lands at the bottom.
  const ARC = 0.75; // fraction of the circle the gauge spans
  const trackDash = `${ARC * circ} ${circ}`;
  const progDash = `${(pct / 100) * ARC * circ} ${circ}`;

  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: 'rotate(135deg)' }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#B98AF9"
          strokeWidth={stroke}
          strokeDasharray={trackDash}
          strokeLinecap="round"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#6C09F7"
          strokeWidth={stroke}
          strokeDasharray={progDash}
          strokeLinecap="round"
        />
      </svg>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span style={{ fontSize: 22.5, fontWeight: 500, color: '#171717', lineHeight: 1 }}>{pct}%</span>
        <span style={{ fontSize: 13.5, fontWeight: 400, color: '#737373', marginTop: 4 }}>Good fit for brand</span>
      </div>
    </div>
  );
}
